export default __webpack_public_path__ + "static/media/Register_Reminder-min.d4b86869.jpg";